import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        {
          staticClass: "justify-center ma-2",
          attrs: { id: "organization-chart" },
        },
        [
          _c("organization-chart", {
            staticClass: "organization",
            attrs: {
              dados: _vm.graficosUnidades.organization.dados,
              fonte: `Sistema Desenvolva, ${_vm.anoMapeamento}`,
              nos: _vm.graficosUnidades.organization.nos,
              titulo: `Equipe da ${_vm.unidade.sigla}`,
            },
          }),
        ],
        1
      ),
      _vm.graficosUnidadesHierarquia.network.nos.length > 1
        ? _c(
            VRow,
            {
              staticClass: "justify-center ma-2",
              attrs: { id: "network-chart" },
            },
            [
              _c("network-chart", {
                staticClass: "network",
                attrs: {
                  dados: _vm.graficosUnidadesHierarquia.network.dados,
                  fonte: `Sistema Desenvolva, ${_vm.anoMapeamento}`,
                  nos: _vm.graficosUnidadesHierarquia.network.nos,
                  titulo: `${_vm.unidade.sigla} - Unidades Vinculadas`,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c("app-sort", {
                model: {
                  value: _vm.opcoes,
                  callback: function ($$v) {
                    _vm.opcoes = $$v
                  },
                  expression: "opcoes",
                },
              }),
            ],
            1
          ),
          _c(VSpacer),
          _c(
            VCol,
            [
              _c("app-search", {
                model: {
                  value: _vm.opcoes,
                  callback: function ($$v) {
                    _vm.opcoes = $$v
                  },
                  expression: "opcoes",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VDataTable, {
                staticClass: "elevation-0",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.relatorio.participantes,
                  search: _vm.opcoes.pesquisa,
                  "sort-by": _vm.opcoes.ordenarPor,
                  "sort-desc": _vm.opcoes.decrescente,
                  "align-content-space-between": "",
                  "disable-pagination": "",
                  "hide-default-footer": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.cargo`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " + _vm._s(item.cargo ? item.cargo : "N/D") + " "
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.funcao`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(item.funcao ? item.funcao : "N/D") +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(VRow, { staticClass: "pa-4" }, [
                            _c(
                              "span",
                              { staticClass: "body-2 secondary--text" },
                              [
                                _c("strong", [_vm._v("* N/D -")]),
                                _vm._v(" Informação não disponível "),
                              ]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-end mb-1" },
        [
          _c(
            VTooltip,
            {
              attrs: { "max-width": "400", top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            attrs: { color: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.getRelatorio()
                              },
                            },
                          },
                          on
                        ),
                        [
                          _c(VIcon, [_vm._v("get_app")]),
                          _vm._v(" BAIXAR PDF "),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("span", [
                _vm._v(
                  "Clique para baixar o relatório dos dados em formato PDF."
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }